<div class="combobox-container">
    <label *ngIf="label" class="input-label" [for]="'comboboxInput-' + name">
        <span class="main-text">{{ label }}</span>
        <span>&nbsp;</span>
        <span class="text-gray-600">{{ labelSecondary }}</span>
    </label>
    <div class="combobox-input-group" #combobox>
        <input
            [formControl]="inputFormControl"
            #inputElementRef
            [id]="'comboboxInput-' + name"
            type="text"
            name="{{ name }}"
            placeholder="{{ placeholder }}"
            class="form-control box-input"
            [autocomplete]="'off'"
            [ngClass]="{
                'is-valid': inputFormControl.valid && inputFormControl.dirty && inputFormControl.value !== '',
                'is-invalid': inputFormControl.touched && !inputFormControl.valid
            }"
            (focus)="handleInputFocus()"
            (blur)="handleInputBlur()"
            (keydown)="handleInputKeydown($event)"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-expanded]="isOptionsPanelVisible"
            [attr.aria-controls]="optionsListId"
            [attr.aria-activedescendant]="highlightedIndex >= 0 ? optionsListId + '-option-' + highlightedIndex : null"
        />
        <label class="combobox-input-group-append" [for]="'comboboxInput-' + name" [ngClass]="{ disabled: disabled }" (click)="disabled ? null : handleArrowClick($event)">
            <fa-icon
                class="input-group-text combobox-input-group-icon combobox-arrow"
                [class.combobox-arrow--open]="isOptionsPanelVisible"
                [icon]="['fas', 'angle-down']"
                [ngClass]="{ 'icon-disabled': disabled }"
            ></fa-icon>
        </label>
        <div *ngIf="inputFormControl.touched && inputFormControl.errors?.['required']" class="invalid-feedback d-block">
            {{ requiredMessage }}
        </div>
    </div>

    <!-- Panel in-flow (default) -->
    <ng-container *ngIf="!panelInOverlay && isOptionsPanelVisible">
        <ng-container *ngTemplateOutlet="optionsTpl; context: { overlay: false }"></ng-container>
    </ng-container>

    <!-- Panel en CDK Overlay (opt-in): escapa el overflow/stacking del modal -->
    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="combobox"
        [cdkConnectedOverlayOpen]="panelInOverlay && isOptionsPanelVisible"
        [cdkConnectedOverlayWidth]="combobox.offsetWidth"
        [cdkConnectedOverlayPositions]="overlayPositions"
    >
        <ng-container *ngTemplateOutlet="optionsTpl; context: { overlay: true }"></ng-container>
    </ng-template>
</div>

<ng-template #optionsTpl let-overlay="overlay">
    <ul class="options" [class.options--overlay]="overlay" role="listbox" [attr.id]="optionsListId" (scroll)="onPanelScroll($event)">
        <li
            *ngFor="let option of visibleOptions; let i = index"
            (mousedown)="onOptionSelected(option)"
            role="option"
            [attr.id]="optionsListId + '-option-' + i"
            [attr.aria-selected]="i === highlightedIndex"
            [class.is-highlighted]="i === highlightedIndex"
            [class.is-create-option]="option.isCreateOption"
        >
            <ng-container *ngIf="option.isCreateOption; else normalOption">
                <fa-icon class="create-option-icon" [icon]="['fas', 'plus']"></fa-icon>
                <span class="create-option-text">{{ createOptionPrefix }}: "{{ option.label }}"</span>
            </ng-container>
            <ng-template #normalOption>
                <span class="option-label">{{ option.label }}</span>
                <span *ngIf="option.sublabel" class="option-sublabel">{{ option.sublabel }}</span>
            </ng-template>
        </li>

        <!-- Estado inicial cargando (modo remoto) -->
        <li *ngIf="loadingInitial" class="options-state" role="presentation">
            <fina-spinner></fina-spinner>
        </li>

        <!-- Cargando la página siguiente: indicador al final sin bloquear el resto -->
        <li *ngIf="loadingMore" class="options-state options-state--loading-more" role="presentation">
            <fina-spinner></fina-spinner>
            <span>Cargando más...</span>
        </li>

        <!-- Falla de red: reintento sin perder los items ya cargados -->
        <li *ngIf="loadError" class="options-state options-state--error" role="presentation" (mousedown)="retryLoad($event)">
            <span>No se pudieron cargar las opciones.</span>
            <button type="button" class="retry-button">Reintentar</button>
        </li>

        <!-- Estado vacío explícito: catálogo vacío o búsqueda sin resultados -->
        <li *ngIf="isEmptyState" class="options-state options-state--empty" role="presentation">
            {{ inputFormControl?.value ? noResultsMessage : emptyMessage }}
        </li>
    </ul>
</ng-template>
